import React from "react";

import image from "../assets/images/picture book b.jpg";
// import image1 from "../assets/images/maths4.jpg";
import image2 from "../assets/images/capital writing.jpg";
import image3 from "../assets/images/sahbd gyan.jpg";
import image4 from "../assets/images/englishpre-primer.jpg";
import image5 from "../assets/images/eco.jpg";
import image6 from "../assets/images/MATH primer.jpg";
import image7 from "../assets/images/SWAR LEKHAN.jpg";

const BookCategories = () => {

  const books = [

    {
      title: "English",
      image: image4,
      position: "top-[0%] left-[38%]",
      color: "bg-[#EEF7FF]",
    },

    {
      title: "Maths",
      image: image6,
      position: "top-[20%] left-[5%]",
      color: "bg-[#FFF0F0]",
    },

    {
      title: "Lekhan",
      image: image7,
      position: "top-[20%] right-[5%]",
      color: "bg-[#FFF8E8]",
    },

    {
      title: "Picture",
      image: image,
      position: "bottom-[20%] left-[8%]",
      color: "bg-[#F4F0FF]",
    },

    {
      title: "Eco",
      image: image5,
      position: "bottom-[20%] right-[8%]",
      color: "bg-[#F4FFF0]",
    },

    {
      title: "Capital",
      image: image2,
      position: "bottom-[0%] left-[30%]",
      color: "bg-[#FFEDED]",
    },

    {
      title: "Gyan",
      image: image3,
      position: "bottom-[0%] right-[30%]",
      color: "bg-[#E8FFF7]",
    },

  ];

  return (

    <section className="py-8 bg-[#FFF9F4] overflow-hidden">

      <div className="max-w-8xl mx-auto px-6">

        {/* Heading */}

        <div className="text-center mb-16">

          <div className="inline-block px-5 py-2 rounded-full bg-[#FFE4D6] text-[#FF6B6B] font-semibold">

            📚 Explore Subjects

          </div>

          <h2 className="text-4xl md:text-6xl font-extrabold text-[#4D96FF] mt-6">

            Discover Learning Adventures 🚀

          </h2>

        </div>

        {/* Orbit */}

        <div className="relative h-[900px] md:h-[700px]">

          {/* Center */}

          <div
            className="

            absolute

            top-1/2

            left-1/2

            -translate-x-1/2

            -translate-y-1/2

            w-80

            h-80

            rounded-full

            bg-gradient-to-r

            from-[#4D96FF]

            via-[#9B5DE5]

            to-[#FF6B6B]

            shadow-2xl

            flex

            flex-col

            items-center

            justify-center

            text-white

            z-20

            "

          >

            <div className="text-7xl mb-3">

              📚

            </div>

            <h3 className="text-3xl font-bold">

              Explore

            </h3>

            <p className="text-lg mt-2">

              Learn • Play • Grow

            </p>

          </div>

          {/* Orbit Line */}

          <div
            className="

            absolute

            top-1/2

            left-1/2

            -translate-x-1/2

            -translate-y-1/2

            w-[650px]

            h-[650px]

            border-4

            border-dashed

            border-[#FFD93D]

            rounded-full

            opacity-30

            "

          ></div>

          {/* Subject Cards */}

          {books.map((book, index) => (

            <div

              key={index}

              className={`

              absolute

              ${book.position}

              w-48

              ${book.color}

              rounded-3xl

              p-4

              shadow-xl

              hover:scale-110

              hover:-translate-y-3

              hover:rotate-2

              transition-all

              duration-300

              cursor-pointer

              z-30

              `}

            >

              <img

                src={book.image}

                alt={book.title}

                className="w-full h-52 object-cover rounded-2xl"

              />

              <h3 className="text-center mt-4 font-bold text-[#4D96FF]">

                {book.title}

              </h3>

            </div>

          ))}

          {/* Floating stars */}

          <div className="absolute top-8 left-10 text-5xl animate-pulse">

            ⭐

          </div>

          <div className="absolute top-20 right-20 text-4xl animate-bounce">

            🌈

          </div>

          <div className="absolute bottom-10 left-20 text-5xl animate-pulse">

            🚀

          </div>

          <div className="absolute bottom-10 right-20 text-4xl animate-bounce">

            🎈

          </div>

        </div>

      </div>

    </section>

  );

};

export default BookCategories;